(function ($) {
  'use strict';

  $(function () {
    var $popup = $('#subscribe-popup');
    if (!$popup.length) return;

    var cookieName = 'subscribe_popup_dismiss';
    var delay = (parseInt($popup.attr('data-delay'), 10) || 5) * 1000;
    var expireDays = parseInt($popup.attr('data-expire'), 10) || 7;

    if ($.cookie && $.cookie(cookieName)) return;

    var timer = setTimeout(function () {
      $popup.addClass('is-open');
      $('body').addClass('subscribe-popup-open');
    }, delay);

    function dismiss() {
      clearTimeout(timer);
      $popup.removeClass('is-open');
      $('body').removeClass('subscribe-popup-open');
      if ($.cookie) $.cookie(cookieName, '1', { expires: expireDays, path: '/' });
    }

    $popup.on('click', '.subscribe-popup__close, .subscribe-popup__overlay', dismiss);
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $popup.hasClass('is-open')) dismiss();
    });
  });
})(jQuery);
